var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),(false)?_c('div',{staticClass:"copyright"},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("\n        Developed by:\n      ")]),_c('li',[_vm._v("John Villafania")]),_c('li',[_c('i',[_vm._v("Front-end")])]),_c('li',[_vm._v("Jan Christian Aristain")]),_c('li',[_c('i',[_vm._v("Back-end")])])])
}]

export { render, staticRenderFns }